import type { AllRouteEndpoints } from "../routeTypes";
export const appsMultiLanguageSettingsDeleteLocaleLocaleIdCacheKeys: AllRouteEndpoints[] = [
  "/apps/multi_language_settings/get_locales",
  "/engagement/:app_group_id/feature_limitations",
];
